import _ from 'underscore';
import {
    ApiRailwayTour, RailwayTariff, Station, RailwayTourProduct,
} from '@ve/types';
import { ApiRailwayLeg } from '@ve/types/railway/ApiRailwayLeg';
import { ApiRailwayRoute } from '@ve/types/railway/ApiRailwayRoute';

import matchRoutesByIds from './matchRoutesByIds';

import apiRailwayToursToRailwayToursProductsAdapter from './apiRailwayToursToRailwayToursProductsAdapter';

export default ({
                    railwayTours,
                    routes,
                    tariffs,
                    legs,
                    stations = [],
                }: {
    railwayTours: ApiRailwayTour[],
    routes: ApiRailwayRoute[],
    tariffs: RailwayTariff[],
    legs: ApiRailwayLeg[],
    stations?: Station[],
}): RailwayTourProduct[] => {
    const routesKeys = _.indexBy(routes, 'id');

    return _.map(railwayTours, (railwayTour) => apiRailwayToursToRailwayToursProductsAdapter({
        railwayTour,
        routes: railwayTour.routes ? matchRoutesByIds({
            routeIds: railwayTour.routes,
            routeReferenceIndex: routesKeys,
        }) : [],
        tariffs,
        legs,
        stations,
    }));
};
